export function getEnumKeys<T>(enumObject: T): T[] {
    return Object.keys(enumObject).map(key => enumObject[key]);
}
